import { API } from '../../../api';
import { axiosInstance } from '../../../utils/fetcher';

const CancelToken = axiosInstance.CancelToken;

let getProjectListEffectCancelToken = () => {};
export const getProjectListEffect = (data) => {
  getProjectListEffectCancelToken();
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetProjectListBySearch`,
    method: 'get',
    params: data,
    cancelToken: new CancelToken(function executor(c) {
      getProjectListEffectCancelToken = c;
    }),
  });
};

let getProjectNameEffectCancelToken = () => {};
export const getProjectNameEffect = (data) => {
  getProjectNameEffectCancelToken();
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetBindProjectList`,
    method: 'get',
    params: data,
    cancelToken: new CancelToken(function executor(c) {
      getProjectNameEffectCancelToken = c;
    }),
  });
};

let checkProjectNameEffectsCancelToken = () => {};
export const checkProjectNameEffects = (data) => {
  checkProjectNameEffectsCancelToken();
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetCheckDuplicateProjectName`,
    method: 'get',
    params: data,
    cancelToken: new CancelToken(function executor(c) {
      checkProjectNameEffectsCancelToken = c;
    }),
  });
};

const getUserProcurementEffectCancelToken = () => {};
export const getUserProcurementEffect = (data) => {
  getUserProcurementEffectCancelToken();
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetUserProcurement`,
    method: 'get',
    params: data,
    cancelToken: new CancelToken(function executor(c) {
      checkProjectNameEffectsCancelToken = c;
    }),
  });
};

export const getTenderByProjectEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetTendersByProject`,
    method: 'get',
    params: data,
  });
};

export const createUpdateProjectEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/PostCreateUpdateProject`,
    method: 'POST',
    data,
  });
};

let getProjectCopyEffectCancelToken = () => {};
export const getProjectCopyEffect = (params) => {
  getProjectCopyEffectCancelToken();
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetProjectCopy`,
    method: 'get',
    params,
    cancelToken: new CancelToken(function executor(c) {
      getProjectCopyEffectCancelToken = c;
    }),
  });
};

export const procurementFileUploadEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/UploadDocument`,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
};

export const procurementFileUploadUpdateEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/UpdateProcurementDocument`,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
};

export const procurementFileDeleteEffect = (params) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/DeleteProcurementDocument`,
    method: 'delete',
    params,
  });
};
